import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface MergeInput {
  winnerId: string;
  loserId: string;
  /** Optional field overrides to apply to the winner before merging (e.g. cherry-picked fields from loser) */
  overrides?: Record<string, unknown>;
}

export const useCustomerMerge = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ winnerId, loserId, overrides }: MergeInput) => {
      // Optionally patch winner with cherry-picked fields from the loser
      if (overrides && Object.keys(overrides).length > 0) {
        const { error: patchErr } = await supabase
          .from("customers")
          .update(overrides)
          .eq("id", winnerId);
        if (patchErr) throw patchErr;
      }

      const { error } = await (supabase.rpc as any)("merge_customers", {
        p_winner_id: winnerId,
        p_loser_id: loserId,
      });
      if (error) throw error;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["customers"] });
      qc.invalidateQueries({ queryKey: ["customers_all_for_duplicates"] });
      qc.invalidateQueries({ queryKey: ["customer_project_counts"] });
      qc.invalidateQueries({ queryKey: ["customer_contacts"] });
      qc.invalidateQueries({ queryKey: ["customer_notes"] });
    },
  });
};
